import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type ResolveIconProps = {
  size?: number
  color?: string
  colorScheme?: 'dark' | 'light'
  className?: string
}

export const ResolveIcon = ({
  size = 20,
  color,
  colorScheme = 'dark',
  className,
}: ResolveIconProps) => {
  const resolvedColor =
    color ??
    (colorScheme === 'light'
      ? tokenVar('colors.light.icon.secondary')
      : tokenVar('colors.icon.secondary'))
  return (
    <svg
      aria-label='Resolve'
      className={className}
      fill='none'
      height={size}
      role='img'
      viewBox='0 0 20 20'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.99996 18.3337C9.99996 18.3337 17 15.0003 17 10.0003V4.16699L9.99996 1.66699L2.99988 4.16699V10.0003C2.99988 15.0003 9.99996 18.3337 9.99996 18.3337Z'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
      <path
        d='M7 9.50004L9.33333 12L13.5 7.5'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
    </svg>
  )
}
